<template>
  <div>
    <div class="d-flex justify-content-between border-bottom p-1 mb-1">
      <h4>{{ $t('tracking.export') }}</h4>
      <feather-icon icon="XIcon" class="close-icon-sidebar-export" size="25" @click="$emit('close')" />
    </div>

    <div class="d-flex flex-column p-1">
      <strong>{{ $t('mediaKits.download') }}</strong>
      <p class="avenir-medium">{{ $t('ia.chat.saveFile') }}</p>
      <b-button 
        variant="outline-secondary mb-1 avenir-medium text-left" 
        @click="$emit('export', 'txt')"
      >
        <b-icon icon="file-earmark-text-fill" /> {{ $t('ia.chat.textFile') }}
      </b-button>
      <b-button 
        variant="outline-secondary avenir-medium text-left" 
        @click="$emit('export', 'doc')"
      >
        <b-icon icon="file-earmark-word-fill" /> {{ $t('ia.chat.wordDocument') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';

export default {
  name: 'ChatExportSidebar',
  components: { BButton },
}
</script>

<style scoped>
.close-icon-sidebar-export:hover {
  cursor: pointer;
  background-color: #eaeaea;
  border-radius: 100%;
}
</style>
